import styled from 'styled-components';
import { CATEGORY_LABELS, type ModerationCategory } from '@/core/models/case';
import { CATEGORY_TONE } from '../meta';

const Badge = styled.span<{ $tone: string }>`
  display: inline-block;
  padding: 2px 8px;
  border-radius: ${({ theme }) => theme.radius.sm};
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-weight: 600;
  color: ${({ $tone }) => $tone};
  background: ${({ $tone }) => `${$tone}22`};
  border: 1px solid transparent;
`;

export function CategoryBadge({ category }: { category: ModerationCategory }) {
  return <Badge $tone={CATEGORY_TONE[category]}>{CATEGORY_LABELS[category]}</Badge>;
}
